module.exports = __webpack_public_path__ + "images/quotas/to_do.svg";